import { AlertTitle as MuiAlertTitle, AlertTitleProps as MuiAlertTitleProps } from '@mui/material';
import * as React from 'react';

export type AlertTitleProps = MuiAlertTitleProps;

export const AlertTitle = (props: AlertTitleProps) => {
  return <MuiAlertTitle {...props} />;
};
